<template>
  <div class="registration">
    <div class="title-section">
      <h1 class="page-title">{{ $props.pageTitle }}</h1>
      <p class="page-subtitle">{{ $props.pageSubtitle }}</p>
    </div>
    <account-form @data-fetched="getChildData"></account-form>
  </div>
</template>

<script>
import AccountForm from '@/components/registration/account-form'

export default {
  name: 'page-create-account',
  components: { AccountForm },
  props: {
    pageTitle: String,
    pageSubtitle: String
  },
  methods: {
    getChildData (data) {
      if (data.token) this.token = data.token
      if (data.email) this.email = data.email
    }
  }
}
</script>

<style scoped lang="scss">
.registration {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: auto;

  .title-section {
    padding: 3.5rem 2.4rem 0;
    text-align: left;

    @media (map_get($breakpoints, sm)) {
      padding-top: 6.5rem;
      text-align: center;
    }
  }

  h1.page-title {
    color: $light-black;
    font-weight: 600;
    margin-bottom: 1.6rem;
    font-size: 2rem;

    @media (map_get($breakpoints, sm)) {
      font-size: 3.2rem;
    }
  }
}
</style>
